var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalfouf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D6A117",
    d: "M52 52s-3-34-29-34C11 18 1 30.295 1 42c0 10 6 10 6 10z",
    opacity: 1,
    "data-original": "#d6a117"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FE8845"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.998 47.665 2.992-33.864 3.984.352-2.992 33.864z",
    fill: "#FE8845",
    opacity: 1,
    "data-original": "#fe8845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.006 43.486 12.852-31.484 3.704 1.512L23.71 44.998z",
    fill: "#FE8845",
    opacity: 1,
    "data-original": "#fe8845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.617 16.373 3.76-1.368 11.628 31.96-3.76 1.368z",
    fill: "#FE8845",
    opacity: 1,
    "data-original": "#fe8845"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 32,
    r: 6,
    fill: "#E6294F",
    opacity: 1,
    "data-original": "#e6294f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 6,
    y: 34,
    fill: "#BA2140",
    rx: 2,
    opacity: 1,
    "data-original": "#ba2140"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 46,
    r: 6,
    fill: "#E6294F",
    opacity: 1,
    "data-original": "#e6294f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99B61E",
    d: "M56 52c-.266-1.273-2.735-5.585-3.128-7-.36-1.296 1.126-4.558.641-5.902-.465-1.289-2.838-1.821-3.435-3.094-.589-1.256.51-3.441-.222-4.624s-3.16-1.152-4.055-2.208c-.903-1.065-.501-3.474-1.583-4.345-1.076-.867-3.308.056-4.576-.56-1.217-.591-1.876-2.93-3.284-3.237-1.296-.283-2.889 1.543-4.358 1.543-1.514 0-3.147-1.814-4.463-1.514-1.443.329-2.094 2.689-3.326 3.322-1.279.658-3.558-.185-4.639.737-1.076.918-.637 3.343-1.546 4.458-.891 1.092-3.333 1.101-4.094 2.321-.75 1.203.294 3.44-.358 4.709-.655 1.276-3.067 1.7-3.649 2.983-.603 1.328 3.53 3.735.098 6.048C7.999 47 7.577 50.78 6.999 52z",
    opacity: 1,
    "data-original": "#99b61e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAC437",
    d: "M63 52s-2-34-24-34S17 52 7 52z",
    opacity: 1,
    "data-original": "#fac437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 17c-1.004 0-1.959.073-2.878.2l1.351-3.311a1 1 0 0 0-.548-1.304l-3.703-1.511a1 1 0 0 0-1.304.548l-2.5 6.127a26.517 26.517 0 0 0-3.719-.612l.257-2.92a.998.998 0 0 0-.908-1.083l-3.984-.35a.995.995 0 0 0-1.084.909l-.318 3.613c-1.339.242-2.667.63-3.966 1.158l-1.386-3.807a.998.998 0 0 0-1.281-.597L9.27 15.428a1 1 0 0 0-.597 1.282l1.751 4.809C4.08 26.39 0 34.365 0 42c0 10.86 6.911 11 6.999 11H63a1.003 1.003 0 0 0 .999-1.059C63.978 51.591 61.682 17 39.001 17zm-5.608-3.696 1.852.755-1.476 3.618c-.736.199-1.444.44-2.123.719a19.836 19.836 0 0 0-.291-.097zM9.208 41.08c.137.27.297.533.453.784.876 1.409 1.177 2.018-.196 2.943-1.603 1.08-2.31 3.186-2.799 4.903A5.012 5.012 0 0 1 5 45.999c0-2.486 1.828-4.537 4.208-4.92zm-.721 9.544c.411-1.474.976-3.403 2.096-4.158 3.026-2.039 1.508-4.483.777-5.657-.172-.277-.424-.682-.483-.879.211-.33.822-.674 1.366-.979.826-.464 1.762-.99 2.222-1.888.451-.878.347-1.932.255-2.86-.067-.678-.144-1.446.063-1.775.215-.345.955-.608 1.608-.84.891-.316 1.812-.644 2.412-1.379.598-.733.757-1.737.898-2.624.108-.684.232-1.459.521-1.706.14-.12.423-.193.84-.219a1 1 0 0 0 .937-1.06.988.988 0 0 0-1.06-.937c-.557.034-1.371.143-2.016.694-.426.364-.685.838-.858 1.35A6.992 6.992 0 0 0 15 25.001c-3.859 0-7 3.14-7 7 0 .337.037.67.085 1H8c-1.654 0-3 1.346-3 3v2a1 1 0 1 0 2 0v-2c0-.551.448-1 1-1h3a1 1 0 1 0 0-2h-.889a4.981 4.981 0 0 1-.111-1c0-2.757 2.243-5 5-5 .943 0 1.855.269 2.643.761-.088.494-.198.945-.391 1.182-.247.302-.93.544-1.532.758-.961.342-2.051.729-2.636 1.666-.566.907-.454 2.036-.355 3.031.064.654.138 1.395-.044 1.75-.186.362-.843.731-1.423 1.057-.815.459-1.722.985-2.176 1.861C5.658 39.517 3 42.451 3 46c0 .976.212 1.923.592 2.793C2.709 47.474 2 45.373 2 42c0-6.834 3.56-13.975 9.143-18.505l.308.847a.999.999 0 1 0 1.879-.685l-2.436-6.692 1.879-.684 2.57 7.06a1 1 0 1 0 1.879-.685l-.842-2.312a18.086 18.086 0 0 1 3.098-.96l-.222 2.527a.998.998 0 0 0 .908 1.083.993.993 0 0 0 1.084-.909l.635-7.224 1.992.175-.604 6.873a.998.998 0 0 0 .997 1.087 1 1 0 0 0 .995-.913l.26-2.959c1.069.1 2.115.26 3.131.489l-.192.471c-6.491 4.331-10.041 12.458-13.075 19.411-2.277 5.22-4.294 9.825-6.902 11.124zm2.81.376c2.258-2.292 4.008-6.303 5.927-10.701C21.364 30.81 26.515 19 39.001 19c18.66 0 22.336 26.343 22.909 32H11.296z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 39a1 1 0 0 0 1 1h2a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1zM54 48h2a1 1 0 1 0 0-2h-2a1 1 0 1 0 0 2zM47 46h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zM38 46h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zM42 38h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalfouf);
export default __webpack_public_path__ + "static/media/Malfouf.a704e16f0bf8a15b394db937c375e98c.svg";
export { ForwardRef as ReactComponent };